import { render, staticRenderFns } from "./referrer-linked-apps.vue?vue&type=template&id=5c55d228"
import script from "./referrer-linked-apps.vue?vue&type=script&lang=js"
export * from "./referrer-linked-apps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports